import React, { useEffect } from "react";
import { Gradient } from "./Gradient.jsx";
import { Row, Col } from "react-bootstrap";

const Header = "Welcome to Fatteh!";
const subHeader ="Our mission is to inform, inspire and empower LGBTQ+ Ethiopians and the global Habesha diaspora.";

function MeshGradientwhatamesh() {
  useEffect(() => {
    // Initialize the gradient after the component mounts
    const gradient = new Gradient();
    gradient.initGradient("#gradient-canvas");
    
  }, [])

  return (
    <div style={{  height: "100vh" }}>
      {/* Canvas for the gradient background */}
      <canvas
        id="gradient-canvas"
        width="100%"
        height="100%"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          "--gradient-color-1": "#D80032",
          "--gradient-color-2": "#82173A",
          "--gradient-color-3": "#B34D70",
          "--gradient-color-4": "#EF233C",
        }}
      />

      <div className="gradient-herotext container h-screen mx-auto flex justify-center items-center relative">
        <div className="flex flex-col justify-start px-48 space-y-12 z-10 ">
          <Row>
            <Col sm={12}md={7}><h1>{Header}</h1></Col>
          </Row>
          <Row>
            <Col sm={12}md={{ span: 6, offset: 5 }}>
            <p>{subHeader}</p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default MeshGradientwhatamesh;